import React from 'react';
import { motion } from 'framer-motion';
import { FileText, BookOpen } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    icon: <FileText className="w-8 h-8 text-gold mb-4" strokeWidth={1.5} data-id="element-15" />,
    title: 'Plantillas para cotizar',
    desc: 'Estructuras listas para copiar, adaptar y enviar a tus clientes hoy mismo.'
  }, {
    icon: <BookOpen className="w-8 h-8 text-gold mb-4" strokeWidth={1.5} data-id="element-16" />,
    title: 'Guía de objeciones',
    desc: 'Respuestas exactas para cuando te dicen "es muy caro" o "lo voy a pensar".'
  }];
  return <section className="bg-cream text-navy py-24 px-5" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        <div className="text-center mb-16" data-id="element-19">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold mb-4" data-id="element-20">
            Material Complementario
          </h2>
          <div className="w-12 h-1 bg-gold mx-auto" data-id="element-21"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-22">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy text-cream p-10 rounded-lg border border-gold/20 flex flex-col items-center text-center relative overflow-hidden group" data-id="element-23">
              <div className="absolute top-0 right-0 bg-gold text-navy text-xs font-bold px-3 py-1 uppercase tracking-wider rounded-bl-lg" data-id="element-24">
                BONUS
              </div>
              {bonus.icon}
              <h3 className="font-playfair text-2xl font-bold mb-3 text-gold" data-id="element-25">
                {bonus.title}
              </h3>
              <p className="font-dmsans text-cream/70 leading-relaxed" data-id="element-26">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}